import { config } from '@iheartjane/config';

export const rootOnlyCustomRowsAllowed = (storeId: string | number) => {
  if (typeof storeId === 'string') {
    return config.rootsOnlyCustomRowStoreIds.includes(parseInt(storeId));
  }

  return config.rootsOnlyCustomRowStoreIds.includes(storeId);
};
